import { useState, useEffect } from 'react';
import ZipFirstField from '../ZipFirstField/ZipFirstField';
import { FaXmark } from 'react-icons/fa6';
import { YEAR } from 'lib/constants';

interface PopdownProps {
  title?: string;
  subtitle?: string;
}

const Popdown: React.FC<PopdownProps> = ({
  title = 'Don’t overpay for solar + batteries',
  subtitle = `Get the best deal for your home in ${YEAR}`,
}) => {
  const [show, setShow] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const handleScroll = () => {
    const navHeight = document.getElementById('navbar')?.offsetHeight || 450;
    if (window.scrollY > navHeight) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!show || !isVisible) return null;

  return (
    <div className="fixed left-0 right-0 bg-gradient-to-b from-slate-100 to-white shadow-lg z-10 top-0 lg:top-[73px]">
      <div className="max-w-7xl mx-auto p-4 relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 text-gray-900"
        >
          <FaXmark className="text-xl" />
        </button>
        <div className="flex flex-col items-center w-full">
          <h2 className="text-xl md:text-2xl font-semibold md:mb-1 text-center">
            {title}
          </h2>
          <p className="mb-1 md:mb-4 text-lg md:text-xl text-center">
            {subtitle}
          </p>
          <div className="flex items-center justify-center w-full max-w-md text-md">
            <ZipFirstField rounded cid="63fs0zqoqizm2p5u" textSize="lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popdown;
